import React, { Fragment } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { theme } from '../../styles/theme';

export interface ILinkedTitle {
  name: string;
  path: string;
}

interface IProps {
  titleList: ILinkedTitle[];
}

const Container = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
  font-size: 14px;
  font-weight: 600;
`;
const Separator = styled.div`
  flex: 0 0 auto;
  color: ${theme.colors.secondary600};
`;
const PreviousPageLink = styled(Link)`
  flex: 0 0 auto;
  font: inherit;
  color: ${theme.colors.secondary600};
  &:hover {
    color: ${theme.colors.mainBlue};
  }
`;
const CurrentName = styled.div`
  flex: 0 0 auto;
  font-weight: 600;
  color: ${theme.colors.secondary900};
`;

/**
 * ClickablePageTitle is a component that renders a list of titles: ITitleList that are clickable.
 * Used in permission pages to allow user to navigate to different layer of pages
 */
const ClickablePageTitle = ({ titleList }: IProps) => {
  return (
    <Container>
      {titleList.map((linkedTitle, index) => {
        const { name, path } = linkedTitle;
        const key = `linked-title-${index}`;

        if (path.length > 0) {
          return (
            <Fragment key={key}>
              <PreviousPageLink to={path}>{name}</PreviousPageLink>
              <Separator>/</Separator>
            </Fragment>
          );
        }

        return <CurrentName key={key}>{name}</CurrentName>;
      })}
    </Container>
  );
};

export default ClickablePageTitle;
